module.exports = __webpack_public_path__ + "static/media/user-plus.52bdb06a.svg";